import { render, staticRenderFns } from "./Disconnect.vue?vue&type=template&id=2cf267ca"
import script from "./Disconnect.vue?vue&type=script&lang=js"
export * from "./Disconnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports